// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"28e65e12","593":"cf0e6597","814":"04c612ff"}[chunkId] + ".chunk.css";
};